import { Component, computed, inject, signal } from '@angular/core';
import { ActivatedRoute, Router as NgRouter } from '@angular/router';
import { BinderCardList } from '@components/partials/binder/binder-card-list/binder-card-list';
import { UiModule } from '@components/ui/ui-module';
import { CardBinder, Scan } from '@models/binder.model';
import { Card } from '@models/card.model';
import { BinderService } from '@services/binder.service';
import { Router } from '@services/route.service';
import { map, tap } from 'rxjs';

@Component({
  selector: 'lgb-card-list',
  imports: [
    UiModule,
    BinderCardList
  ],
  templateUrl: './card-list.html',
  styleUrl: './card-list.css',
})
export class CardList {
  //services
  readonly binderS=inject(BinderService);
  readonly route=inject(ActivatedRoute);
  readonly ngRouter=inject(NgRouter);
  readonly router=inject(Router);

  //data
  readonly cardBinder=signal<CardBinder[]>([]);
  readonly references=signal<Card[]>([]);
  readonly scans=signal<Scan[]>([]);

  //ui
  readonly loading=signal(true);
  private fragment: string=null;
  readonly start=signal(0);
  readonly length=20;
  readonly page=computed(() => this.start()/this.length);

  constructor(){
    this.route.fragment.subscribe(fragment => this.fragment=fragment);
    this.route.queryParamMap
      .subscribe(params => {
        let start: number=parseInt(params.get('start'));
        if(isNaN(start))
          start=0;
        this.start.set(start)
      });
  }

  getSearchObs(){
    return (q: string, start: number, length: number) => {
      this.router.setUrlAttribute({start});
      return this.binderS.getMyCards(start, length)
        .pipe(
          map(response => {
            this.references.set(response.references);
            this.scans.set(response.scans);
            return response.cardBinder;
          }),
          tap(cards => {
            if(this.fragment && cards.find((c: CardBinder) => c.ident==this.fragment)){
              setTimeout(() => {
                document.getElementById(this.fragment)?.scrollIntoView({ behavior: 'instant', block: 'center' });
                this.router.removeFragment();
              }, 200);
            }
          }),
        );
    }
  }
}
